import { gql } from '@apollo/client'

export default gql(`
    mutation deleteApp($project: String $id: ID!
        ) {
        deleteApp(
            id: $id
            project: $project
        ) {
                id
               }
               
    }`
)
